import React from 'react';
import {Box} from '../Box/Box';
import {FooterCopyright} from './FooterCopyright';
import {FooterNav} from './FooterNav';
import type {BoxProps} from '../Box/Box';

export interface FooterProps extends Pick<BoxProps, 'sx' | 'component' | 'children'> {
    /**
     * Attribute to specify date if needed.
     */
    copyrightYear?: string;
    /**
     * Replaces entire copyright text.
     */
    copyrightText?: string;
    /**
     * Toggle copyright divider.
     */
    copyrightDivider?: boolean;
}

export const Footer = React.forwardRef<any, FooterProps>(({
    children, sx,
    copyrightYear, copyrightText, copyrightDivider,
    ...props
}, ref): React.ReactElement => {
    const isPadded = React.Children.count(children) > 0 && !copyrightDivider;

    return (
        <Box
            component='footer'
            ref={ref}
            sx={{
                paddingY: isPadded ? '0.5rem' : 0,
                backgroundColor: (theme): string => theme.tokens.FuelColorGray200,
                overflow: 'hidden',
                gridArea: 'footer',
                ...sx
            }}
            {...props}
        >
            {/**
             * TODO:
             * I wanted to do this in a way where we can control the
             * the padding from this component instead of FooterContainer
            */}
            { React.Children.map<React.ReactNode, React.ReactNode>(children, (child) => {
                if (React.isValidElement(child)) {
                    if (child.type === FooterNav && !copyrightDivider) {
                        return React.cloneElement(child, {
                            sx: {
                                paddingBottom: 0
                            }
                        });
                    }
                }

                return child;
            }) }
            <FooterCopyright
                divider={copyrightDivider}
                text={copyrightText}
                year={copyrightYear}
            />
        </Box>
    );
});

Footer.displayName = 'Footer';
